import { render, staticRenderFns } from "./allowance.vue?vue&type=template&id=3052a5c4&scoped=true&"
import script from "./allowance.vue?vue&type=script&lang=js&"
export * from "./allowance.vue?vue&type=script&lang=js&"
import style0 from "./allowance.vue?vue&type=style&index=0&id=3052a5c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052a5c4",
  null
  
)

export default component.exports